// extracted by mini-css-extract-plugin
module.exports = {"root":"Video_root__1CM2V","video":"Video_video__YCEDe"};